import { render } from "./MenuIcon.vue?vue&type=template&id=2d395620&scoped=true"
import script from "./MenuIcon.vue?vue&type=script&lang=js"
export * from "./MenuIcon.vue?vue&type=script&lang=js"

import "./MenuIcon.vue?vue&type=style&index=0&id=2d395620&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d395620"]])

export default __exports__